import type { Service, ServiceOption } from "../store/types";

const NOW = "2026-03-24T00:00:00Z";

export const MOCK_SERVICES: Service[] = [
  {
    id: "svc-001",
    service_code: "photography_8h",
    title_zh: "8小時攝影",
    title_en: "8-Hour Photography",
    title_ja: "8時間フォトグラフィー",
    short_desc_zh: "全天與在地攝影師同行，捕捉您在城市中真實而珍貴的每一刻。",
    short_desc_en: "A full day alongside a local photographer capturing your authentic moments across the city.",
    short_desc_ja: "地元フォトグラファーと一日を過ごし、都市の中で本物の瞬間を捉えます。",
    base_price_twd: 18800,
    duration_hours: 8,
    city_scope: ["kyoto"],
    cover_image_url:
      "https://public.readdy.ai/ai/img_res/08d3886f84783c80883db7a81aa65811.jpg",
    icon: "ri-camera-line",
    features: [
      { zh: "8小時專屬陪拍", en: "8 hours of dedicated coverage", ja: "8時間の専属撮影" },
      { zh: "100+ 張精修數位照片", en: "100+ edited digital photos", ja: "100枚以上のレタッチ済みデジタル写真" },
      { zh: "私人線上相冊", en: "Private online gallery", ja: "プライベートオンラインギャラリー" },
    ],
    is_active: true,
    sort_order: 1,
    created_at: NOW,
    updated_at: NOW,
  },
  {
    id: "svc-002",
    service_code: "photography_video",
    title_zh: "攝影 + 短影片",
    title_en: "Photography + Short Video",
    title_ja: "フォトグラフィー＋ショートムービー",
    short_desc_zh: "包含所有攝影套餐內容，並加入電影質感的短片記錄。",
    short_desc_en: "Everything in the photography package, plus a cinematic short film of your day.",
    short_desc_ja: "写真パッケージのすべてに加え、映画のような短編フィルムも。",
    base_price_twd: 28800,
    duration_hours: 8,
    city_scope: ["kyoto"],
    cover_image_url:
      "https://readdy.ai/api/search-image?query=cinematographer%20filming%20couple%20in%20Japan%20beautiful%20soft%20light%20cinematic%20style%20film%20aesthetic%20moody%20emotional%20storytelling%20camera%20equipment%20Japanese%20garden%20sakura&width=400&height=320&seq=service-photo-video&orientation=landscape",
    icon: "ri-video-line",
    features: [
      { zh: "含所有攝影套餐服務", en: "All photography package benefits", ja: "写真パッケージのすべての特典" },
      { zh: "60–90 秒電影風格短片", en: "60–90 second cinematic video", ja: "60〜90秒のシネマティック動画" },
      { zh: "含配樂與調色", en: "Soundtrack & color grading included", ja: "サウンドトラック・カラーグレーディング込み" },
    ],
    is_active: true,
    sort_order: 2,
    created_at: NOW,
    updated_at: NOW,
  },
];

export const MOCK_SERVICE_OPTIONS: ServiceOption[] = [
  {
    id: "opt-001",
    service_id: "svc-001",
    option_code: "extra_4h",
    title_zh: "加購4小時",
    title_en: "Extra 4 Hours",
    title_ja: "4時間追加",
    price_delta_twd: 8000,
    is_active: true,
    sort_order: 1,
  },
  {
    id: "opt-002",
    service_id: "svc-001",
    option_code: "rush_delivery",
    title_zh: "加急交件（3工作日）",
    title_en: "Rush Delivery (3 business days)",
    title_ja: "急ぎ納品（3営業日）",
    price_delta_twd: 3000,
    is_active: true,
    sort_order: 2,
  },
  {
    id: "opt-003",
    service_id: "svc-002",
    option_code: "extended_video",
    title_zh: "延長影片至3分鐘",
    title_en: "Extended Video (3 min)",
    title_ja: "動画延長（3分）",
    price_delta_twd: 5000,
    is_active: true,
    sort_order: 1,
  },
];
